<template>
  <div>
    <div slot="title">
      <h2>Evaluadores Asignados</h2>
    </div>
    <div slot="main">
      <div class="container-fluid">
        <div class="row" style="margin-top:20px;">          
          <div class="col-3">
            <button type="button" class="form-control" @click="volver">
              <i class="fa fa-arrow-left"></i><span class="label label-default" style="margin-left:5px;">Volver</span>
            </button>
          </div>
          
        </div>
        <div class="row" style="margin-top:30px;">
          <div class="col-12">
            <table class="table table-striped table-light table-hover" id="tablaEvaluadores">
              <thead class="thead-dark">
                <tr>
                  <th class="text-center">ID Evaluador</th>
                  <th class="text-center">Nombre de evaluador</th>
                  <th class="text-center">Puesto</th>
                  <th class="text-center">Tipo de Evaluador</th>
                  <th class="text-center">Estatus de evaluación</th>
                  <th class="text-center">Acciones</th>
                </tr>
              </thead>
              
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import comun from '@/../static/js/comun'
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import axios from 'axios'
  import Vue from 'vue'

  export default {
    props: ['idEvaluacion'],//Recibe como parametro el id de la evaluación
    data() {
      return {
        
      }
    },
    components: {

    },
    methods: {
      volver: function () {//Retorna  la página /SIAP/DetallesEvaluado
        this.$router.push({
          name: 'DetallesEvaluado', 
          params: { idEvaluacion: this.idEvaluacion }
        })
      },
      buscarEvaluadores: function () {//Hace la petición para obtener a los evaluadores de la evaluación
        //Carga los valores requeridos para hacer la petición
        var peticion = {
          "esPrueba": false,
          "idEvaluacion": this.idEvaluacion
        };
        axios.post(api.conexion + api.SISEVA.funcion.GetEvaluadores, peticion).then(response => {
          if (response.data.SiHayError == false) {//En caso de que la petición sea exitosa
            var filas = new Vue({//Crea un componente tbody de vue que contiene la información acerca de los evaluadores
              template: "<tbody class='text-dark'>"+
                "<tr v-for='evaluador in evaluadores'>" +
                "<td>{{ evaluador.Evaluador.IdPersona }}</td>"+
              "<td>{{evaluador.Evaluador.NombreCompleto}}</td>"+
                "<td>{{evaluador.Evaluador.Puesto}}</td>" +
                "<td>{{evaluador.TipoEvaluador}}</td>"+
              "<td>{{evaluador.EstatusEvaluacion}}</td>"+                     
                "<td  class='d-flex justify-content-around'>" +
                "<i class='fa fa-toggle-on' v-if='evaluador.Activo'/>"+
                "<i class='fa fa-toggle-off' v-if='!evaluador.Activo'/>"+
                "<i class='fa fa-info-circle'/>"+
                "</td>" +
              "</tr></tbody>",
              data: {
                evaluadores: response.data.evaluadores//Carga los datos requeridos
              }
            })
            filas.$mount()
            $("#tablaEvaluadores").find("tr:gt(0)").remove();
            $('#tablaEvaluadores').append(filas.$el);//Borra todas las filas de la tabla y agrega las recien obtenidas
          }
          else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null)
          }
          }).catch(e => {
            console.error("encontre un error "+e);
            comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null)
          });
      }
    }
    , mounted: function mounted() {//Al cargar la página busca la información sobre los evaluadores
      this.buscarEvaluadores()
    }

  }

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/SISEVA/Evaluaciones/EvaluadoresAsignados.vue